import { Container, Stack } from '@mui/material';
import { UserInfo } from 'Components/UserInfo';
import { useIsDesktop } from 'Hooks';
import { useShowUserInfo } from 'Hooks/useShowUserInfo';
import { Outlet } from 'react-router-dom';

export const IFrameLayout = () => {
  const isDesktop = useIsDesktop();
  const showUserInfo = useShowUserInfo();
  return (
    <Container
      maxWidth={'lg'}
      sx={{
        overflow: 'hidden',
        minHeight: 'calc(100vh - 72px - 477px)',
        paddingX: isDesktop ? '' : '24px',
      }}
      component={'main'}
    >
      <Stack
        paddingTop={{ sm: '28px', xs: '20px' }}
        paddingBottom={{ sm: '80px', xs: '65px' }}
        paddingLeft={{ lg: '65px', sm: '24px', xs: '0' }}
        paddingRight={{ sm: '24px', xs: '0' }}
        tabIndex={-1}
      >
        {showUserInfo && <UserInfo />}
        <Outlet />
      </Stack>
    </Container>
  );
};
